import { FC, useState } from 'react'
import { useIntl } from 'react-intl';

interface ProductProps {
    id: string;
    title: string;
    description: string;
    image: string;
    video: string;
    message: string
}

interface ProductBannerProps {
    product: ProductProps;
}

const ProductBanner: FC<ProductBannerProps> = ({ product }) => {
    const intl = useIntl()
    // check window size
    const [windowSize, setWindowSize] = useState<number>(window.innerWidth)

    window.addEventListener('resize', () => {
        setWindowSize(window.innerWidth)
    })    
    const WA_NUMBER = "6282330779799";
    const encodedMessage = encodeURIComponent(product.message);
    const WA_LINK = `https://api.whatsapp.com/send?phone=${WA_NUMBER}&text=${encodedMessage}`;

    return (
        <div className="outer">
            <div className="inner"></div>
            <div className={`${windowSize >= 1024 && 'w-65'} container-fluid container-product-banner position-relative py-5`}>
                <img src={`/assets/icons/${product!.image}.png`} alt="" className="img-fluid img-product-banner pb-4 mb-2" />
                <h2 className='sora title-product-banner pb-4'>{product!.title}</h2>
                <h5 className='sora desc-product-banner pb-4'>{product!.description}</h5>
                <a href={WA_LINK} className={`btn btn-jumbotron-orange mb-5 sora`} target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: "CTA.BUTTON" })}</a>
                <div className={`video-container w-100`}>
                    <video loop muted autoPlay controls={false} className='product-video'>
                        <source src={`/assets/videos/${product!.video}.mp4`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </div>
    )
}

export { ProductBanner }